import React, { useState } from 'react';

const Testimonials: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonials = [
        {
            name: "Daniel Kim",
            role: "Investment Banking Associate",
            avatar: "/carousel/avatar1.jpg",
            timeAgo: "1 day ago",
            text: "Hush gave me access to opportunities I never would have found on my own. The process was private, simple, and respectful of my time."
        },
        {
            name: "Sarah Johnson",
            role: "Product Manager",
            avatar: "/carousel/avatar2.jpg",
            timeAgo: "2 days ago",
            text: "The AI matchmaking was spot on. I was connected with companies that truly aligned with my career goals. No more wasting time on irrelevant applications."
        },
        {
            name: "Michael Chen",
            role: "Data Scientist",
            avatar: "/carousel/avatar3.jpg",
            timeAgo: "3 days ago",
            text: "Being able to stay anonymous until I was ready to engage was a game changer. It took the pressure off and let me focus on finding the right fit."
        }
    ];

    const handlePrevious = () => {
        setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    };

    return (
        <section className="relative px-4 pt-4 pb-2 sm:pt-10 sm:pb-10 overflow-x-hidden">
            <div className="container mx-auto max-w-[1640px]">
                {/* Container */}
                <div className="sm:min-h-[571px]" style={{ position: 'relative', width: '100%', maxWidth: '1600px', height: 'auto', margin: '0 auto' }}>
                    {/* Title */}
                    <h2
                        className="relative sm:absolute text-left mb-8 sm:mb-0 sm:top-0 sm:left-0"
                        style={{
                            width: '100%',
                            maxWidth: '1600px',
                            fontFamily: 'Manrope',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: 'clamp(32px, 6vw, 96px)',
                            lineHeight: '1.2',
                            letterSpacing: '-0.05em',
                            color: '#FFFFFF',
                        }}
                    >
                        What candidates are saying
                    </h2>

                    {/* Carousel Container */}
                    <div className="relative sm:absolute w-full sm:w-auto sm:left-[10%] sm:right-[10%] mt-8 sm:mt-0 sm:top-[207px]" style={{ height: 'auto', minHeight: '364px' }}>
                        <div className="hidden sm:flex items-center justify-between gap-4">
                            {/* Left Arrow */}
                            <button
                                onClick={handlePrevious}
                                className="flex-shrink-0 relative"
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '0px',
                                    gap: '10px',
                                    isolation: 'isolate',
                                    width: '44px',
                                    height: '44px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    background: 'linear-gradient(87.95deg, #015FA6 -15.78%, #B7E6FF 102.06%)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                }}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18L9 12L15 6" stroke="#FFFFFF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>

                            {/* Outer Testimonial Card (Frame 845) */}
                            <div
                                className="w-full"
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 'clamp(16px, 3vw, 20px)',
                                    gap: '10px',
                                    minHeight: '250px',
                                    background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                                    border: '1px solid rgba(255, 255, 255, 0.15)',
                                    boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15)',
                                    filter: 'drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.05)) drop-shadow(0px 15px 30px rgba(0, 0, 0, 0.05)) drop-shadow(0px 30px 60px rgba(0, 0, 0, 0.1))',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: 'clamp(20px, 4vw, 40px)',
                                }}
                            >
                                {/* Inner Content Card (Frame 1618871089) */}
                                <div style={{
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 'clamp(12px, 3vw, 24px)',
                                    gap: '10px',
                                    width: 'calc(100% - clamp(32px, 6vw, 40px))',
                                    margin: 'clamp(8px, 1.5vw, 10px) 0',
                                    borderRadius: '20px',
                                    background: 'rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(255, 255, 255, 0.05)'
                                }}>
                                    <div className="w-full" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0px', gap: 'clamp(16px, 4vw, 32px)' }}>
                                        {/* User Info and Text */}
                                        <div className="w-full" style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', padding: '0px', gap: 'clamp(12px, 2vw, 16px)' }}>
                                            {/* Avatar */}
                                            <div
                                                style={{
                                                    width: '44px',
                                                    height: '44px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)',
                                                    border: '1px solid #FFFFFF',
                                                    filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))',
                                                    overflow: 'hidden',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Manrope', fontWeight: 600, fontSize: '18px', color: '#FFFFFF' }}>
                                                    {testimonials[currentIndex].name.charAt(0)}
                                                </div>
                                            </div>

                                            {/* Name, Role, and Text */}
                                            <div className="flex-1" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0px', gap: '20px' }}>
                                                {/* Name and Role */}
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0px', gap: '4px', width: '100%', position: 'relative' }}>
                                                    {/* Name */}
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0px', gap: '4px' }}>
                                                        <h4
                                                            style={{
                                                                fontFamily: 'Manrope',
                                                                fontWeight: 600,
                                                                fontSize: 'clamp(18px, 3vw, 24px)',
                                                                lineHeight: '120%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                color: '#FFFFFF',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {testimonials[currentIndex].name}
                                                        </h4>
                                                    </div>

                                                    {/* Role and Time */}
                                                    <div className="flex-wrap sm:flex-nowrap" style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 2vw, 18px)' }}>
                                                        <p
                                                            style={{
                                                                fontFamily: 'Manrope',
                                                                fontWeight: 400,
                                                                fontSize: 'clamp(12px, 2vw, 20px)',
                                                                lineHeight: '120%',
                                                                color: '#9D9BA6',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {testimonials[currentIndex].role}
                                                        </p>
                                                        <div className="hidden sm:block" style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#9D9BA6', flexShrink: 0 }} />
                                                        <p
                                                            className="hidden sm:block"
                                                            style={{
                                                                fontFamily: 'Manrope',
                                                                fontWeight: 400,
                                                                fontSize: 'clamp(12px, 2vw, 20px)',
                                                                lineHeight: '120%',
                                                                color: '#9D9BA6',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {testimonials[currentIndex].timeAgo}
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Testimonial Text */}
                                                <p
                                                    style={{
                                                        fontFamily: 'Manrope',
                                                        fontWeight: 400,
                                                        fontSize: 'clamp(14px, 2.5vw, 20px)',
                                                        lineHeight: '140%',
                                                        color: '#CAC6DD',
                                                        margin: 0,
                                                        width: '100%',
                                                    }}
                                                >
                                                    "{testimonials[currentIndex].text}"
                                                </p>
                                            </div>
                                        </div>

                                        {/* Pagination */}
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', padding: '0px', gap: '16px' }}>
                                            {testimonials.map((_, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => setCurrentIndex(index)}
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '9px',
                                                        gap: '8px',
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '24px',
                                                        border: 'none',
                                                        background: 'transparent',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: '6px',
                                                            height: '6px',
                                                            borderRadius: '50%',
                                                            background: index === currentIndex ? '#FFFFFF' : '#CAD1E9',
                                                        }}
                                                    />
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Arrow */}
                            <button
                                onClick={handleNext}
                                className="flex-shrink-0 relative"
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '0px',
                                    gap: '10px',
                                    isolation: 'isolate',
                                    width: '44px',
                                    height: '44px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    background: 'linear-gradient(87.95deg, #015FA6 -15.78%, #B7E6FF 102.06%)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                }}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18L15 12L9 6" stroke="#FFFFFF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        {/* Mobile view - card only, no arrows */}
                        <div className="sm:hidden">
                            {/* Outer Testimonial Card (Frame 845) */}
                            <div
                                className="w-full"
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 'clamp(16px, 3vw, 20px)',
                                    gap: '10px',
                                    minHeight: '250px',
                                    background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                                    border: '1px solid rgba(255, 255, 255, 0.15)',
                                    boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15)',
                                    filter: 'drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.05)) drop-shadow(0px 15px 30px rgba(0, 0, 0, 0.05)) drop-shadow(0px 30px 60px rgba(0, 0, 0, 0.1))',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: 'clamp(20px, 4vw, 40px)',
                                }}
                            >
                                {/* Inner Content Card (Frame 1618871089) */}
                                <div style={{
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 'clamp(12px, 3vw, 24px)',
                                    gap: '10px',
                                    width: 'calc(100% - clamp(32px, 6vw, 40px))',
                                    margin: 'clamp(8px, 1.5vw, 10px) 0',
                                    borderRadius: '20px',
                                    background: 'rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(255, 255, 255, 0.05)'
                                }}>
                                    <div className="w-full" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0px', gap: 'clamp(16px, 4vw, 32px)' }}>
                                        {/* User Info and Text */}
                                        <div className="w-full" style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', padding: '0px', gap: 'clamp(12px, 2vw, 16px)' }}>
                                            {/* Avatar */}
                                            <div
                                                style={{
                                                    width: '44px',
                                                    height: '44px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)',
                                                    border: '1px solid #FFFFFF',
                                                    filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))',
                                                    overflow: 'hidden',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Manrope', fontWeight: 600, fontSize: '18px', color: '#FFFFFF' }}>
                                                    {testimonials[currentIndex].name.charAt(0)}
                                                </div>
                                            </div>

                                            {/* Name, Role, and Text */}
                                            <div className="flex-1" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0px', gap: '20px' }}>
                                                {/* Name and Role */}
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0px', gap: '4px', width: '100%', position: 'relative' }}>
                                                    {/* Name */}
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0px', gap: '4px' }}>
                                                        <h4
                                                            style={{
                                                                fontFamily: 'Manrope',
                                                                fontWeight: 600,
                                                                fontSize: 'clamp(18px, 3vw, 24px)',
                                                                lineHeight: '120%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                color: '#FFFFFF',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {testimonials[currentIndex].name}
                                                        </h4>
                                                    </div>

                                                    {/* Role and Time */}
                                                    <div className="flex-wrap sm:flex-nowrap" style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 2vw, 18px)' }}>
                                                        <p
                                                            style={{
                                                                fontFamily: 'Manrope',
                                                                fontWeight: 400,
                                                                fontSize: 'clamp(12px, 2vw, 20px)',
                                                                lineHeight: '120%',
                                                                color: '#9D9BA6',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {testimonials[currentIndex].role}
                                                        </p>
                                                        <div className="hidden sm:block" style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#9D9BA6', flexShrink: 0 }} />
                                                        <p
                                                            className="hidden sm:block"
                                                            style={{
                                                                fontFamily: 'Manrope',
                                                                fontWeight: 400,
                                                                fontSize: 'clamp(12px, 2vw, 20px)',
                                                                lineHeight: '120%',
                                                                color: '#9D9BA6',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {testimonials[currentIndex].timeAgo}
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Testimonial Text */}
                                                <p
                                                    style={{
                                                        fontFamily: 'Manrope',
                                                        fontWeight: 400,
                                                        fontSize: 'clamp(14px, 2.5vw, 20px)',
                                                        lineHeight: '140%',
                                                        color: '#CAC6DD',
                                                        margin: 0,
                                                        width: '100%',
                                                    }}
                                                >
                                                    "{testimonials[currentIndex].text}"
                                                </p>
                                            </div>
                                        </div>

                                        {/* Pagination */}
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', padding: '0px', gap: '16px' }}>
                                            {testimonials.map((_, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => setCurrentIndex(index)}
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '9px',
                                                        gap: '8px',
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '24px',
                                                        border: 'none',
                                                        background: 'transparent',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: '6px',
                                                            height: '6px',
                                                            borderRadius: '50%',
                                                            background: index === currentIndex ? '#FFFFFF' : '#CAD1E9',
                                                        }}
                                                    />
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
